import { AccountType, RecordType } from '@xbcb/shared-types';
import { FinancialOnboardingStatus } from '@xbcb/party-types';
import {
  checkAccess,
  UserPermissions,
} from '@xbcb/client-utils/dist/checkAccess';
import { executeMutation } from 'libs/executeMutation';
import { updateOneMutation } from '@xbcb/shared-queries';
import { AppRecordKebabMenuItem } from '../../types';

const updateShipperMutation = updateOneMutation({
  recordName: RecordType.SHIPPER,
  fields: `id version financeOnboardingDetails { financeOnboardingRequired status }`,
});

/**
 * "Retry Finance Onboarding" kebab menu item.
 * Visible only to operators viewing a shipper whose finance provisioning has FAILED.
 * Action: sets financeOnboardingRequired=true, which the backend uses to
 * clear status and re-trigger the GATI finance onboarding pipeline.
 */
export const appRecordRetryFinanceOnboardingMenuItem: AppRecordKebabMenuItem = {
  key: 'retryFinanceOnboarding',
  text: 'Retry Finance Onboarding',
  show: ({ currentUser, existingRecord }) =>
    currentUser?.accountType === AccountType.OPERATOR &&
    checkAccess(currentUser, RecordType.SHIPPER, UserPermissions.UPDATE) &&
    existingRecord?.financeOnboardingDetails?.status ===
      FinancialOnboardingStatus.FAILED,
  action: async ({ record }) => {
    await executeMutation({
      mutation: updateShipperMutation,
      variables: {
        id: record.id,
        version: record.version,
        input: {
          financeOnboardingDetails: {
            financeOnboardingRequired: true,
          },
        },
      },
    });
  },
  confirmAction: true,
};
